import React from 'react';

import { ImpressionWatcher } from 'js/utils/impressions';
import { ButtonLink } from 'js/design_system/link/ButtonLink';

import routes from 'js/core_pre_webpack/routes';

export function AgsAiTwinMarketingButton() {
  return (
    <ImpressionWatcher source="ags.ai_twin_navbar">
      <ButtonLink
        href={routes.ags_ai_assistant_url({
          from_navbar: true,
          trigger: 'nav',
        })}
        icon="chat_bubble"
        size="sm"
      >
        AI Assistant
      </ButtonLink>
    </ImpressionWatcher>
  );
}
